import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { ReactLenis } from "lenis/react";
import { MotionConfig } from "framer-motion";
import { HelmetProvider } from "react-helmet-async";
import { Toaster } from "@/components/ui/sonner";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import RouteSeo from "@/components/Seo";
import Home from "@/pages/Home";
import Studio from "@/pages/Studio";
import Academie from "@/pages/Academie";
import Legal from "@/pages/Legal";

// Anciennes URL du site Wix → nouvelle page la plus pertinente
const WIX_REDIRECTS = {
  "/general-7": "/studio",
  "/copie-de-à-propos": "/studio",
  "/copie-de-maquillage-permanent-sourcils-1": "/studio",
  "/copie-de-maquillage-permanent-sourcils-2": "/academie",
  "/inquiry-services-page": "/studio#reservation",
  "/book-online": "/studio#reservation",
  "/conditions-de-réservation-et-d-annulatio": "/cgv",
  "/conditions-générales-d-utilisation": "/cgv",
  "/mentions-légales": "/mentions-legales",
  "/politique-de-confidentialité": "/confidentialite",
  "/service-page/microshading": "/studio#sourcils-mp",
  "/service-page/microblading": "/studio#sourcils-mp",
  "/service-page/browlift": "/studio#sourcils-soins",
  "/service-page/réhaussement-de-cils": "/studio",
  "/service-page/retouche-1-mois": "/studio#sourcils-mp",
  "/service-page/retouche-2-à-6-mois": "/studio#sourcils-mp",
  "/service-page/retouche-6-à-12-mois": "/studio#sourcils-mp",
  "/service-page/retouche-12-à-18-mois": "/studio#sourcils-mp",
  "/service-page/retouche-18-mois-et-plus": "/studio#sourcils-mp",
};

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

function App() {
  return (
    <HelmetProvider>
      <MotionConfig reducedMotion="user">
        <BrowserRouter>
          <ReactLenis root options={{ duration: 1.15, smoothWheel: true }}>
            <ScrollToTop />
            <RouteSeo />
            <div className="grain-overlay" aria-hidden="true" />
            <Header />
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/studio" element={<Studio />} />
              <Route path="/academie" element={<Academie />} />
              <Route path="/mentions-legales" element={<Legal page="mentions" />} />
              <Route path="/cgv" element={<Legal page="cgv" />} />
              <Route path="/confidentialite" element={<Legal page="confidentialite" />} />
              {Object.entries(WIX_REDIRECTS).map(([from, to]) => (
                <Route key={from} path={from} element={<Navigate to={to} replace />} />
              ))}
              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
            <Footer />
            <Toaster position="top-center" />
          </ReactLenis>
        </BrowserRouter>
      </MotionConfig>
    </HelmetProvider>
  );
}

export default App;
